import React, { useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';

const Counter = ({ from = 0, to, duration = 2, suffix = '', className = '' }) => {
  const nodeRef = useRef();
  const inView = useInView(nodeRef, { once: false, margin: '-10px' });

  useEffect(() => {
    const node = nodeRef.current;
    if (!node) return;

    if (inView) {
      let startTime = null;
      let animationFrameId;

      const animate = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / (duration * 1000), 1);

        const currentValue = Math.floor(from + (to - from) * progress);
        node.textContent = currentValue + suffix;

        if (progress < 1) {
          animationFrameId = requestAnimationFrame(animate);
        }
      };

      animationFrameId = requestAnimationFrame(animate);

      return () => {
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
      };
    } else {
      // Réinitialiser quand l'élément sort de l'écran
      if (node) {
        node.textContent = from + suffix;
      }
    }
  }, [inView, from, to, duration, suffix]);

  return (
    <span ref={nodeRef} className={className}>
      {from}
      {suffix}
    </span>
  );
};

export default Counter;